export default __webpack_public_path__ + "static/media/exam.a3561435.svg";